export default {
  name: 'oz-icon-remove-filter',
  render () {
    return (
      <span class="icon icon-color--primary">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 16 16" xml:space="preserve" style="stroke: currentColor">
          <line x1="3" x2="13" y1="3" y2="13" style="stroke-width: 2;" />
          <line x1="3" x2="13" y1="13" y2="3" style="stroke-width: 2;" />
        </svg>
      </span>
    )
  },
}
